export default function AboutHero() {
  return (
    <section className="relative bg-[#1A1A1A] text-white py-20 md:py-32 px-4 md:px-8 overflow-x-hidden">
      <div className="max-w-7xl mx-auto text-center">
        <h1
          className="text-[32px] md:text-5xl lg:text-6xl font-bold mb-6 leading-tight"
          style={{ fontFamily: 'Montserrat, sans-serif' }}
        >
          Building Better Since 2000
        </h1>
        <p className="text-base md:text-xl text-gray-300 max-w-3xl mx-auto px-0">
          From a single workshop in Johannesburg to South Africa's most trusted building supplies brand built on quality, reliability and the professionals who choose us every day.
        </p>
      </div>
    </section>
  );
}